// material-ui
import { Box, Typography } from '@mui/material';

// project import
import MainLayout from '../../../layout/MainLayout';
import React, { useState } from 'react';
import MainCard from '../../../components/MainCard';
import { useSelector } from 'react-redux';
import Button from '../../../components/Button';
import ConfirmationModal from './ConfirmationModal';

const ConsultaMassivaPage = () => {

  const { message } = useSelector((state) => state.consultaMassiva);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  return (
    <MainLayout>
      <>
        <MainCard
          title="Consulta Massiva - Propostas Bradesco"
          border={false}
        >
          <Box>
            <Typography variant="h4" >
              {message}
            </Typography>
          </Box>
          <Box sx={{mt: 2}}>
            <Button variant="contained" color="primary" onClick={() => setOpen(true)} sx={{ mr: 1 }}>
              Executar
            </Button>
          </Box>
        </MainCard>
        <ConfirmationModal
          open={open}
          handleClose={handleClose}
        />
      </>
    </MainLayout>
  );
};

export default ConsultaMassivaPage;
